import { jsx as _jsx } from "react/jsx-runtime";
import { useFetch, usePromise } from '@rad/hooks';
import { getPublicTourSummary } from '../../../../common/network/tour';
import { districtUrls } from '../../../../common/routes/urls/district';
import { backToTour } from '../_tour-home';
import TourHomeLoading from './tour-home-loading';
import TourHomeUnavailable from './tour-home-unavailable';
// The tour is not live, or not this community's. A tour that is there gets named, and its page is
// one tap away; one that is not sends people to the community's tours.
const TourUnavailable = (props) => {
    const [summaryPromise] = useFetch(getPublicTourSummary(props.id));
    const summary = usePromise(summaryPromise);
    if (summary === undefined)
        return _jsx(TourHomeLoading, {});
    if (summary === null) {
        return _jsx(TourHomeUnavailable, { message: "This tour is not available.", href: districtUrls.tours.getURL(), label: "See all tours" });
    }
    const message = summary.status === 'archived'
        ? `${summary.title} is no longer available.`
        : `${summary.title} is not yet available.`;
    return _jsx(TourHomeUnavailable, Object.assign({ message: message }, backToTour(props.id, props.previewing)));
};
export default TourUnavailable;
